<script setup lang="ts">
import { CountUp } from 'countup.js'
import { useRecipientLanding } from '@consumer/modules/recipientGiftLandingV2/composables'
import { isTest } from '@shared/environment'

const {
  secondaryBgColor,
  gift,
} = $(useRecipientLanding())

const emit = defineEmits(['counterDone'])

const counter = $computed(() => new CountUp('amount-counter', gift?.amount || 0, {
  duration: isTest ? 0.1 : 2.0,
  prefix: '$',
  useEasing: false,
}))

function start () {
  return new Promise<void>((resolve) => {
    counter?.reset()
    counter?.start(() => {
      emit('counterDone')
      resolve()
    })
  })
}

defineExpose({
  start,
  reset: () => counter?.reset(),
})
</script>

<template>
  <span
    id="amount-counter"
    class="font-semibold"
    :style="{ color: secondaryBgColor, fontSize: '100px' }"
  />
</template>
